"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var Part = /** @class */ (function (_super) {
            __extends(Part, _super);
            function Part(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // Register with root form's serialize event so we can propagate it to our partForm
                if (_this.Root && _this.Root.serializeTransitState) {
                    _this.onSerializeTransitStateSubscriptionId = _this.Root.serializeTransitState.subscribe(_this.onSerializeTransitState.bind(_this));
                }
                if (_this.Root && _this.Root.onClose) {
                    _this.rootCloseSubscriptionId = _this.Root.onClose.subscribe(_this.onRootClose.bind(_this));
                }
                _this.canLoadPromise = $dyn.deferred.onTrue(function () {
                    return _this.canLoadForm();
                });
                $.when(_this.canLoadPromise).done(function () {
                    _this.asyncload = $dyn.async(function () {
                        var getResourceName = function () {
                            var resource = "";
                            if (typeof _this.Resource === "string") {
                                resource = _this.Resource;
                            }
                            else {
                                var resourceValue = $dyn.value(_this.Resource);
                                if (resourceValue) {
                                    resource = resourceValue.menuItem;
                                }
                            }
                            return resource;
                        };
                        var options = {
                            name: getResourceName(),
                            parameters: {
                                Part: _this,
                            },
                            ShouldBlockOnExecution: false,
                            targetElement: $('[data-dyn-role="PartForm"]', element)[0] || $('[data-dyn-role="FactBoxForm"]', element)[0],
                        };
                        // If we are reloading this part from another window, then FormId will exist.
                        // We will want to send this into the call to .createForm so that the data-dyn-formid attribute is set
                        // on the div where the partForm will live after being reserialized from the server.
                        if ($dyn.value(_this.FormId)) {
                            options.id = $dyn.value(_this.FormId);
                            options.formPart = true;
                            options.context = $dyn.serverForm.getModel($dyn.value(_this.FormId));
                        }
                        // While opening the form part, put it in a layout block so that layout does not occur until after the form part loads
                        $dyn.ui.layout(true);
                        var targetElement = $dyn.shell.createForm(options);
                        _this.ClientFormId = targetElement.getAttribute("data-dyn-formid");
                        $dyn.ui.layout(false);
                    }, undefined, "Load form part");
                });
                return _this;
            }
            Part.prototype.onSerializeTransitState = function () {
                // When we receive this event from our root form, propagate it to our PartForm.
                if (this.PartForm) {
                    this.PartForm.serializeTransitState.raise();
                }
            };
            /** @internal */
            Part.prototype.readFormId = function () {
                var _this = this;
                var targetElement = $('[data-dyn-role="PartForm"]', this.element)[0] || $('[data-dyn-role="FactBoxForm"]', this.element)[0];
                var formId = targetElement.getAttribute("data-dyn-formid");
                $dyn.async(function () {
                    $dyn.setValue(_this, "FormId", formId);
                }, undefined, "Set part form id.");
            };
            /**
             * Returns Child form controls
             * @returns Array of child forms
             */
            Part.prototype.getChildForms = function () {
                var childrenInsideContainer = [];
                var formElements = $(this.element).find('[data-dyn-role="PartForm"]');
                if (formElements && formElements.length > 0) {
                    childrenInsideContainer.push($dyn.context(formElements[0]));
                    if (formElements.length > 1) {
                        $dyn.logError("Part: More than one form found");
                    }
                }
                return childrenInsideContainer;
            };
            /**
             * Sets the part as the active control on the root form.
             */
            Part.prototype.activate = function () {
                $dyn.log.focus && $dyn.log.focus("Activate: Part Control(Form.Id: %s)->Activate", this.element.getAttribute("data-dyn-form-name"));
                // Set this part as the active control on the main form if it isn't already the active control.
                if (this.Root && this.Root.ActiveControl) {
                    var activeControlName = this.Root.ActiveControl();
                    var activeElement = this.Root.findControl(activeControlName);
                    if (activeElement && $dyn.context(activeElement)) {
                        if ($dyn.context(activeElement).Id !== this.Id) {
                            // Setting the active control without setting the focus.
                            var takeFocusValue = $dyn.value(this.Root.TakeFocus);
                            var findFocusTargetValue = this.Root.FindFocusTarget;
                            $dyn.setValue(this.Root, "TakeFocus", false);
                            this.Root.FindFocusTarget = undefined;
                            this.Root.activateControl(this, true);
                            $dyn.setValue(this.Root, "TakeFocus", takeFocusValue);
                            this.Root.FindFocusTarget = findFocusTargetValue;
                        }
                    }
                }
            };
            /**
             * Sets focus to a child control in the part form.
             */
            Part.prototype.setChildControlFocus = function () {
                var partFormElement = $(this.element).find("form")[0];
                if (partFormElement) {
                    // Get the context of the part form hosted by the part control.
                    var partFormContext = $dyn.context(partFormElement);
                    if (partFormContext) {
                        // Find the focusable child control in the part form.
                        var childElement = this._getFocusableChildElement(partFormContext);
                        // Call setFocus with the parent form for this control as the root.
                        if (childElement) {
                            this.setFocus(childElement, partFormContext);
                            return childElement;
                        }
                    }
                }
            };
            Part.prototype.dispose = function () {
                if (this.canLoadPromise && this.canLoadPromise.reject) {
                    this.canLoadPromise.reject();
                }
                if (this.asyncload && this.asyncload.cancel) {
                    this.asyncload.cancel();
                }
                if (this.onSerializeTransitStateSubscriptionId !== undefined) {
                    if (this.Root && this.Root.serializeTransitState && this.Root.serializeTransitState.unsubscribe) {
                        this.Root.serializeTransitState.unsubscribe(this.onSerializeTransitStateSubscriptionId);
                    }
                    this.onSerializeTransitStateSubscriptionId = undefined;
                }
                if (this.rootCloseSubscriptionId !== undefined) {
                    if (this.Root && this.Root.onClose && this.Root.onClose.unsubscribe) {
                        this.Root.onClose.unsubscribe(this.rootCloseSubscriptionId);
                    }
                    this.rootCloseSubscriptionId = undefined;
                }
                _super.prototype.dispose.call(this);
            };
            Part.prototype.canLoadForm = function () {
                return $dyn.value(this.Visible);
            };
            Part.prototype.onRootClose = function () {
                var _this = this;
                // Only close the PartForm if we have reference to one and our Root is not being detached for popout.
                if (this.PartForm && this.Root && !this.Root.detachedForPopout) {
                    // If the DOM is getting cleaned up and it's not for the popout scenario, call close on the nested PartForm
                    // Use $dyn.async since we are currently responding to a DeleteViewModel Interaction and the InteractionChannel will be busy.
                    // This also allows for the close of the form in JSD to wait for all pending part form closes.
                    $dyn.async(function () {
                        $dyn.callFunction(_this.PartForm.RequestCloseCancel, _this.PartForm);
                    }, undefined, "Call RequestCloseCancel on PartForm");
                }
            };
            /**
             * Gets the active control as the focusable child element.If no active control is found, then returns the first focusable child control in the container.
             */
            Part.prototype._getFocusableChildElement = function (partForm) {
                var childElementToFocus;
                if (partForm.ActiveControl()) {
                    var activeControlName = partForm.ActiveControl();
                    childElementToFocus = partForm.findControl(activeControlName);
                }
                var elementToFocus = childElementToFocus ? childElementToFocus : $dyn.util.findFirstFocusableControl(this.element);
                return $(elementToFocus)
                    .addBack()
                    .closest("[data-dyn-controlname]")[0];
            };
            return Part;
        }($dyn.ui.Container));
        controls.Part = Part;
        Part.prototype.ObjectName = "";
        Part.prototype.Visible = true;
        Part.prototype.Caption = "";
        Part.prototype.FormId = "";
        Part.prototype.LoadInline = false;
        Part.prototype.IsFirstChild = false;
        Part.prototype.RefreshInterval = 0;
        Part.prototype.PartForm = null;
        $dyn.ui.addObservablePropertiesToPrototype(Part.prototype, {
            Expanded: false,
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Part.js.map
